// src/components/Timeline.js
import React from 'react';
import TimelineItem from './TimelineItem';
import '../index.css'; // We'll create this CSS file next.

const Timeline = () => {
    const timelineData = [
        {
            text: 'Started as a Junior Developer at Tech Solutions Inc.',
            date: 'March 2021',
            category: {
                tag: 'Work',
                color: '#ff6b6b'
            },
            link: {
                url: 'https://techsolutions.com',
                text: 'Learn more'
            }
        },
        {
            text: 'Completed a full-stack development bootcamp.',
            date: 'December 2020',
            category: {
                tag: 'Education',
                color: '#4ecdc4'
            }
        },
        {
            text: 'Launched my first personal project: a recipe finder app.',
            date: 'June 2022',
            category: {
                tag: 'Project',
                color: '#4ecdc4'
            },
            link: {
                url: 'https://recipe-finder-app.com',
                text: 'View Project'
            }
        },
        {
            text: 'Promoted to a Mid-Level Developer.',
            date: 'April 2023',
            category: {
                tag: 'Work',
                color: '#ff6b6b'
            }
        },
    ];

    return (
        <div className="timeline-container">
            {timelineData.map((data, idx) => (
                <TimelineItem data={data} key={idx} />
            ))}
        </div>
    );
};

export default Timeline;